import { create, StateCreator } from "zustand"
import { CompilationModel } from "@tm/data/compilations"
import { DialogCustomRepairTime } from "./EditDialog"

export type OwnRepairTimesSlice = OwnRepairTimesState & OwnRepairTimesActions

type OwnRepairTimesState = {
    selectedCompilation?: CompilationModel
    searchQuery: string
    repairTimeToEdit?: DialogCustomRepairTime
    isSaving?: boolean
}

type OwnRepairTimesActions = {
    setSelectedCompilation(compilation?: CompilationModel): void
    setSearchQuery(query?: string): void
    setRepairTimeToEdit(editObject?: DialogCustomRepairTime): void
    setIsSaving(value: boolean): void
}

const initialState: OwnRepairTimesState = {
    searchQuery: "",
}

export const createOwnRepairTimesState: StateCreator<OwnRepairTimesSlice, [["zustand/devtools", never]]> = (set) => ({
    ...initialState,
    setSelectedCompilation: (selectedCompilation) => set((state) => ({ ...state, selectedCompilation })),
    setSearchQuery: (searchQuery) => set((state) => ({ ...state, searchQuery })),
    setRepairTimeToEdit: (editObject) => set((state) => ({ ...state, repairTimeToEdit: editObject })),
    setIsSaving: (isSaving) => set((state) => ({ ...state, isSaving })),
})

export const useOwnRepairTimesStore = create(createOwnRepairTimesState)
